import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useServices } from "@/context/ServicesContext";
import { ServiceRow } from "@/components/app/ServiceRow";
import { ClientContactCard } from "@/components/app/ClientContactCard";
import { ClientServicesCard } from "@/components/app/ClientServicesCard";

export const ClientHistorySheet = ({ name, version, onClose }) => {
  const { openNew } = useServices();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!name) return;
    api.get("/clients/history", { params: { name } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [name, version]);

  const done = items.filter((s) => s.status === "realizado").length;

  return (
    <Sheet open={!!name} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="right" className="thin-scroll w-full overflow-y-auto border-slate-700 bg-slate-900 sm:max-w-xl" data-testid="client-history-sheet">
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-3xl font-extrabold tracking-tight" data-testid="client-history-name">{name}</SheetTitle>
          <SheetDescription>{done} realizado(s) · {items.length - done} agendado(s)</SheetDescription>
        </SheetHeader>
        {name && <ClientContactCard name={name} />}
        {name && <ClientServicesCard name={name} version={version} />}
        <Button onClick={() => openNew({ client_name: name })} className="mt-5 w-full rounded-full font-semibold" data-testid="client-add-service-button">
          <Plus className="mr-1 h-4 w-4" /> Lançar atendimento para este cliente
        </Button>
        <div className="mt-6 text-xs font-semibold uppercase tracking-wider text-slate-400">Histórico de atendimentos</div>
        {items.length === 0 && <p className="mt-3 text-sm text-slate-500" data-testid="client-history-empty">Nenhum atendimento lançado ainda.</p>}
        <ol className="relative mt-3 space-y-3 border-l border-slate-700 pl-4" data-testid="client-history-list">
          {items.map((s) => (
            <li key={s.id} className="relative">
              <span className="absolute -left-[21px] top-5 h-2.5 w-2.5 rounded-full border-2 border-slate-900 bg-slate-400" />
              <ServiceRow s={s} />
            </li>
          ))}
        </ol>
      </SheetContent>
    </Sheet>
  );
};
